import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/settings.svg";

const SettingsIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default SettingsIcon;
